 /*
创建者 魏强(2018.3.8)
*/
<template>
    <div class="swipe-wrap">
        <div class="swipe">
            <Carousel
                v-model="value"
                :autoplay="setting.autoplay"
                :autoplay-speed="setting.autoplaySpeed"
                :dots="setting.dots"
                :radius-dot="setting.radiusDot"
                :trigger="setting.trigger"
                :arrow="setting.arrow"
            >
                <CarouselItem v-for="item in list" :key="item.key">
                    <div :style="styleObject">
                        <router-link :to="item.url" target="_blank">
                            <img :src="item.atturl" :alt="item.aname"   class="scrollLoading">
                        </router-link>
                    </div>
                </CarouselItem>
            </Carousel>
        </div>
    </div>
</template>
<script>
import {parseAdvList} from "utils/tool.js";
    export default{
        props:["data","size"],
        computed:{
            styleObject:function(){
                return {
                    height:this.size.height,
                    width:this.size.width
                }
            }
        },
        data(){
            return {
                list : parseAdvList(this.data),
                value:0,
                setting: {
                    autoplay: true,
                    autoplaySpeed: 5000,
                    dots: 'inside',
                    radiusDot: true,
                    trigger: 'hover',
                    arrow:"never"
                }
            }
        }
    }
</script>
<style scoped>
    a,img{
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// banner.vue?76bad91e